
    <div class="full-height-div">
        <!-- Content inside the centered div -->
        <div class="content">
            <img src="assets/img/ic_pro.png" alt="Sample Image">
             <h1>Fluidra Pro</h1> 
        </div>
    </div>